import {useCallback} from 'react'
import {useNavigate} from 'react-router'

import {Role} from '~/api/types/employee'
import {useCompanyUser} from '~/shell/user'
import tracking from '~/tracking'

import {trackWalletTopUp, TrackWalletTopUpAction} from './tracking'
import {useAutoTopUpPermissions} from './use-auto-top-up-permissions'
import {useBankTransferModal} from './use-bank-transfer-modal'
import {useHasAWalletLoad} from './use-has-a-wallet-load'
import {useIsOpenBankingEnabled} from './use-is-open-banking-enabled'
import {useWalletModalContext} from './wallet-modal-context'

export const useHandleTopUp = () => {
    const navigate = useNavigate()
    const user = useCompanyUser()
    const {hasAWalletLoad} = useHasAWalletLoad()
    const {isVisible: isAutoTopUpAvailable} = useAutoTopUpPermissions()
    const isOpenBankingTopUpEnabled = useIsOpenBankingEnabled()

    const {openWalletModal} = useWalletModalContext()
    const {openBankTransferModal} = useBankTransferModal()

    const handleTopUp = useCallback(() => {
        trackWalletTopUp({action: TrackWalletTopUpAction.CLICK_TOP_UP_BUTTON})

        if (user.role === Role.OWNER && !hasAWalletLoad) {
            // Pleo Guide only allows users with the 'owner' role
            navigate('/onboarding/pleo-guide/topup-wallet')
            tracking.walletOnboardingTopupViewed()

            return
        }

        if (isAutoTopUpAvailable) {
            tracking.walletTopupMethodModalViewed()
            openWalletModal('topUpMethod')
        } else if (isOpenBankingTopUpEnabled) {
            openWalletModal('openBanking')
        } else {
            openBankTransferModal()
        }
    }, [
        hasAWalletLoad,
        isAutoTopUpAvailable,
        isOpenBankingTopUpEnabled,
        navigate,
        openBankTransferModal,
        openWalletModal,
        user.role,
    ])

    return {
        handleTopUp,
    }
}
